export const COMPONENT_TYPE = {
    Unspecified: 0,
    Inverter: 1,
    PV_Module: 2,
    PV_System: 3,
    Wind_Turbine: 4,
    Efficiency_Investment: 5,
    Generic_Photovoltaic: 6,
    Fuel_Cell: 7,
    Roof_Benefit: 8,
    Load_Controller: 9,
    System_Performance_Meter: 10,
    Battery: 11,
    System_Costs: 12,
    Solar_Water_Collector: 13,
    Unused: 14,
    Solar_Water_Tank: 15,
    Solar_Water_Auxiliary_Tank: 16,
    Integrated_Energy_Storage: 17,
    Storage_System_Inverter: 18
};
